import classes from "./styles.module.scss";
import { FaPlay } from "react-icons/fa";
export const PlayIcon = ({ ...props }) => {
  return (
    <FaPlay size={props.width || 16} className={classes.icon} {...props} />
  );
};
